/**
 * Mobile-only product-grid layout toggle.
 *
 * Switches the target grid between one and two products per row on phone widths,
 * persists the choice in localStorage, and re-applies it whenever the element is
 * (re)connected — which covers the AJAX filter/sort renders that replace the grid.
 */
class CollectionLayoutToggle extends HTMLElement {
  static STORAGE_KEY = 'collection-mobile-layout';
  static LAYOUTS = ['1', '2'];

  connectedCallback() {
    this.grid = this.dataset.gridId ? document.getElementById(this.dataset.gridId) : null;
    if (!this.grid) return;

    this.buttons = Array.from(this.querySelectorAll('[data-layout]'));
    this.applyLayout(this.getStoredLayout(), false);

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.applyLayout(button.dataset.layout, true));
    });
  }

  get defaultLayout() {
    return CollectionLayoutToggle.LAYOUTS.includes(this.dataset.defaultLayout) ? this.dataset.defaultLayout : '1';
  }

  getStoredLayout() {
    try {
      const stored = localStorage.getItem(CollectionLayoutToggle.STORAGE_KEY);
      return CollectionLayoutToggle.LAYOUTS.includes(stored) ? stored : this.defaultLayout;
    } catch (error) {
      return this.defaultLayout;
    }
  }

  applyLayout(layout, persist) {
    if (!CollectionLayoutToggle.LAYOUTS.includes(layout)) layout = this.defaultLayout;

    CollectionLayoutToggle.LAYOUTS.forEach((value) => {
      this.grid.classList.toggle(`product-grid--mobile-${value}`, value === layout);
    });

    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.layout === layout ? 'true' : 'false');
    });

    if (!persist) return;

    try {
      localStorage.setItem(CollectionLayoutToggle.STORAGE_KEY, layout);
    } catch (error) {
      // Storage unavailable (e.g. private mode) — the selection still applies for this session.
    }
  }
}

customElements.define('collection-layout-toggle', CollectionLayoutToggle);
